import { Base } from "../Base";
import { Name } from "../Name";
export class Class extends Base {
    base;
    class = "union";
    _name;
    get name() {
        return (this._name ??= Name.fromUnion(this.base));
    }
    get definition() {
        return Object.assign(super.definition, { base: this.base.map(b => b.definition) });
    }
    constructor(base, name) {
        super();
        this.base = base;
        this._name = name;
    }
    is(value) {
        return this.base.some(b => b.is(value));
    }
    prune(value) {
        let result = undefined;
        for (const base of this.base)
            if ((result = base.prune(value)))
                break;
        return result;
    }
    flawed(value) {
        const result = super.flawed(value);
        return (result && {
            ...result,
            flaws: this.base.map(t => t.flawed(value)).filter((v) => v != false),
        });
    }
    static create(...base) {
        return new Class(base);
    }
}
//# sourceMappingURL=Class.js.map